




































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import MeterModelForm from '@/data/models/meter-model-form';
import DateUtils from '@/helpers/date-utils';
import MeterIdentificationResponses from '@/data/models/meterModelResponse';
import Button from '@/components/commons/Button.vue';
import CreateMeterIdentifications from "@/components/meters/detail/CreateMeterIdentifications.vue";

@Component({
  components: {CreateMeterIdentifications, Button},
})
export default class MeterIdentifications extends Vue {
  @Prop({required: true})
  meterId: string;

  @Prop({required: true})
  buildingId: string;

  isProcessing: boolean = false;
  isRefreshing: boolean = false;
  opened: boolean = false;

  meterIdentifications: MeterIdentificationResponses[] = [];
  meterModelForm: MeterModelForm = MeterModelForm.map({});
  scilabErrors = [];

  headers = [
    {text: 'Identifiant', value: 'id'},
    {text: 'Date de génération', value: 'date'},
  ];

  @Watch('meterId',{immediate: true})
  onMeterIdChange(): void {
    this.refresh();
  }

  formatDate(date: string): string {
    return DateUtils.toDDMMYYYYHHmm(DateUtils.isoStringToDate(date));
  }

  handleCreate(): void {
    this.opened = true;
    this.meterModelForm = MeterModelForm.map({meterId: this.meterId, buildingId: this.buildingId});
  }

  modalClose(): void {
    this.opened = false;
    this.refresh();
  }

  refresh(): void {
    this.isRefreshing = true;
    this.getModels().then(() => this.isRefreshing = false);
    this.getScilabErrors();
  }

  getScilabErrors(): void {
    this.$dao.logs.getScilabLogs(this.meterId).then((result) => {
      if (result) {
        this.scilabErrors = result;
      } else {
        this.scilabErrors = [];
      }
    });
  }

  getModels(): Promise<void> {
    this.isProcessing = true;
    return this.$dao.meters.getMeterIdentifications(this.meterId).then((result) => {
      if (result != null) {
        this.meterIdentifications = result;
      }
    }).finally(() => this.isProcessing = false);
  }
}
